import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/system';
import StyledTextField from '../../../styled/TextField';
import VirtualTable from '../../../partials/VirtualTable';
import { CircularProgress, Grid, IconButton } from '@mui/material';
import { Clear, PictureAsPdf } from '@mui/icons-material';
import store from '../../../../store';
import { setSelectedMeshId, setSelectedProjectElementId } from '../../../../store/actions/Project';
import { useDebounce } from '../../../../utils/Utils';

const columns = [
    { id: 'segment', title: 'Seg', numeric: true, style: { minWidth: '55px' } },
    { id: 'position', title: 'Pos', numeric: true, style: { minWidth: '55px' } },
    {
        id: 'art_number', title: 'ArtNr', numeric: false,
        style: { overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', minWidth: '160px' }
    },
    {
        id: 'description', title: 'Descriptions', numeric: false,
        style: { overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', minWidth: '320px' }
    },
    { id: 'ean', title: 'EAN', numeric: true, style: { minWidth: '128px' } },
    { id: 'quantity', title: 'Quantity', numeric: true, style: { minWidth: '96px' } },
];

const SearchProjectElements = (props) => {
    const {
        elements,
        onRowClick,
        selectedChecker,
        downloadReportPdf,
        loading,
        isPublic
    } = props;

    const [search, setSearch] = useState('');
    const [filteredElements, setFilteredElements] = useState(null);

    const { t } = useTranslation();

    const debouncedSearch = useDebounce(search, 500);

    useEffect(() => {
        if (debouncedSearch !== '') {
            const filtered = elements.filter((element) => {
                const data = element.art_number + ' ' + element.description + ' ' + element.ean;
                return data.toLowerCase().includes(debouncedSearch.toLowerCase());
            });

            if (filtered && filtered.length === 1 && filtered[0].art_number === debouncedSearch) {
                const { external_id, guid } = filtered[0];
                store.dispatch(setSelectedMeshId(external_id));
                store.dispatch(setSelectedProjectElementId(guid.toUpperCase()));
            } else {
                //store.dispatch(setSelectedMeshId(null));
                //store.dispatch(setSelectedProjectElementId(null));
            }

            setFilteredElements(filtered);
        } else {
            setFilteredElements(null);
        }
    }, [debouncedSearch, elements]);

    return (
        <>
            <Grid container>
                <Grid item xs={isPublic ? 12 : 10} md={isPublic ? 12 : 11}>
                    <StyledTextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        label={t('Search')}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        InputProps={{
                            endAdornment: search && (
                                <IconButton
                                    size="small"
                                    onClick={() => setSearch('')}
                                    sx={{ visibility: search ? 'visible' : 'hidden' }}
                                >
                                    <Clear fontSize="small" color="primary" />
                                </IconButton>
                            ),
                        }}
                    />
                </Grid>
                {
                    !isPublic && (
                        <Grid item xs={2} md={1} alignContent='center' justifyItems='end' justifyContent='end'>
                            {
                                loading
                                    ? (
                                        <CircularProgress size={24} sx={{ marginLeft: '10px' }} />
                                    )
                                    : (
                                        <IconButton onClick={downloadReportPdf}>
                                            <PictureAsPdf color='primary' />
                                        </IconButton>
                                    )
                            }
                        </Grid>
                    )
                }
            </Grid>
            <Box sx={{ paddingTop: 2, height: 'calc(100% - 40px)' }}>
                <VirtualTable
                    rows={filteredElements || elements}
                    columns={columns}
                    onRowClick={onRowClick}
                    selectedChecker={selectedChecker}
                    rowHeight={50}
                    isProductFixtures={true}
                />
            </Box>
        </>
    );
};

export default SearchProjectElements;
